<template>
    <div class="share_vehicle">
        <p>
            Compartir:
            <a href="#"
                ><i class="fa fa-facebook-square" aria-hidden="true"></i
            ></a>
            <a href="#"
                ><i class="fa fa-twitter-square" aria-hidden="true"></i
            ></a>
            <a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a>
        </p>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
